var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"href":_vm.block.attrs.url,"value":_vm.block.attrs.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }